<template>
  <div :class="$style.container">
    <iframe
      width="100%"
      height="226px"
      :src="`${embedUrl}/feature=oembed`"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      :class="$style.video"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'YoutubeCard',
  components: {},

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    embedUrl() {
      return this.item.embed_link.embed_url.replace(
        'youtu.be',
        'www.youtube.com/embed'
      )
    },
  },
}
</script>

<style lang="scss" module>
.video {
  border-radius: 8px;
}
.container {
  display: flex;
  justify-content: center;
}
</style>
